<template>
  <div class="customer-read-proposals">
    <former-box
      title="Propostas"
      subtitle="Histórico de propostas"
      collapsable
    >
      <state-messages
        key="customer-read-proposals-state"
        class="customer-read-proposals-state"
        :state="state"
        :iconed="false"
      >
        <template v-slot:loading>
          Carregando propostas
        </template>

        <template v-slot:error>
          Algo deu errado enquanto tentávamos carregar as propostas.
          Por favor, tente novamente.
        </template>

        <template v-slot:empty>
          Nenhuma proposta cadastrada
        </template>
      </state-messages>

      <template v-if="list.length">
        <router-link
          v-for="proposal in list"
          :key="proposal.id"
          :to="url(proposal)"
          class="customer-read-proposals-item"
        >
          <proposal-list-item
            :proposal="proposal"
            date
            class="list-slow"
          />
        </router-link>
      </template>
    </former-box>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  import { SORT_METHODS } from '@/_CRUDL/helpers/data/sort';

  import FormerBox from '@/components/Former/Box.vue';
  import ProposalListItem from '@/components/Proposals/List/Item.vue';
  import StateMessages from '@/components/State/Messages.vue';

  export default {
    name: 'CustomerReadInformationsProposals',
    components: {
      FormerBox,
      ProposalListItem,
      StateMessages,
    },
    props: {
      customer: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    computed: {
      ...mapState([
        'proposals',
      ]),

      list() {
        return Object.values(this.proposals.list.items).sort((a, b) => b.id - a.id);
      },
      state() {
        const {
          error,
          loading,
        } = this.proposals.list;

        if (loading) {
          return 'loading';
        }

        if (error) {
          return 'error';
        }

        return Object.keys(this.list).length ? 'ready' : 'empty';
      },
    },
    beforeMount() {
      this.clearProposals();
    },
    mounted() {
      this.getProposals();
    },
    methods: {
      url(proposal) {
        return {
          name: 'proposals-read',
          params: {
            id: proposal.id,
          },
        };
      },

      clearProposals() {
        this.$store.dispatch('proposals/clear', { action: 'list' });
      },
      getProposals() {
        if (String(this.customer.id) !== String(this.$route.params.id)) {
          return;
        }

        this.$store.dispatch('proposals/list', {
          customer: this.customer.cpf || this.customer.cnpj,
          sort: SORT_METHODS.created_at_desc.value,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .customer-read-proposals {
    border-bottom: $spacing solid $gray-light;
  }

  .customer-read-proposals-item {
    background-color: $gray-light;
    border-radius: $button * 0.5;
    display: block;
    margin: 0 (-$gutter-small);
    padding: $gutter-small $gutter $gutter-small + $gutter-smaller;

    & + & {
      margin-top: $gutter-small;
    }

    &:hover {
      background-color: $blue-light;
    }

    @media all and (min-width: $breakpoint-desktop) {
      padding: $gutter $gutter-big $gutter + $gutter-smaller;
    }
  }

  .customer-read-proposals-state {
    padding: 0;
  }
</style>
